import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'src/utils/translate';
import Link from 'next/link';
import { connect } from 'react-redux';
import PostItem from 'src/modules/shared/resultsList/components/postItem';
import FeaturedPost from 'src/modules/community/shared/components/featuredPosts/featuredPost';
import { translationWithLink } from 'src/utils/i18n/translationUtils';
import FooterCTA from 'src/modules/community/shared/components/communityFooterCTA';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import PostListLoader from 'src/modules/shared/resultsList/components/postListLoader';
import PostFilterDropdown from 'src/components/postFilterDropdown';
import config from 'config/config';

class CommunityHomeContent extends React.Component {
  static propTypes = {
    filter: PropTypes.string.isRequired,
    combinedPosts: PropTypes.array,
    community: PropTypes.object,
    currentUser: PropTypes.object,
    fetchPosts: PropTypes.func,
    isPostListLoading: PropTypes.bool,
    isWriteCTAvisible: PropTypes.bool,
    widgets: PropTypes.array,
  };

  static defaultProps = {
    combinedPosts: [],
    community: null,
    currentUser: null,
    fetchPosts: () => {},
    isPostListLoading: false,
    isWriteCTAvisible: true,
    widgets: [],
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  renderPost = post => {
    const { community, currentUser } = this.props;
    if (!post) return null;
    if (post.featuredPostId) {
      return (
        <FeaturedPost featuredPost={post} key={post.featuredPostId} />
      );
    } else {
      return (
        <PostItem
          community={community}
          currentUser={currentUser}
          isSearchPost={false}
          key={post.postId}
          post={post}
        />
      );
    }
  };

  renderPostList() {
    const { combinedPosts, community } = this.props;
    return combinedPosts.length > 0 ? (
      <div className="results-posts">
        {combinedPosts.map(this.renderPost)}
        <div className="results__see-more-cta">
          <Link
            as={`/${community.slug}/posts`}
            href={`/community/communityPosts?slug=${community.slug}`}
          >
            <a onClick={() => {
              trackFootfallEvent(footfallEventTypes.CLICKED, {
                clickType: 'see-all-posts',
                clickMetadata: { section: 'community-home' },
              });
            }}>
              {i18n.t('See all posts')} <span className="icon icon-right-open" />
            </a>
          </Link>
        </div>
      </div>
    ) : (
      <div className="community__home-empty">
        {translationWithLink(i18n.t('Nothing here yet! Be the first to %1$s share your experience %2$s!'), {
          href: `/${community.slug}/write`,
        })}
      </div>
    );
  }

  render() {
    const {
      filter,
      fetchPosts,
      community,
      currentUser,
      isPostListLoading,
      isWriteCTAvisible,
      widgets,
    } = this.props;
    const pinnedPostsWidget = widgets.find(x => x.widgetType === 'PinnedPosts');
    const isPinnedPostsLinkEnabled = !!pinnedPostsWidget && pinnedPostsWidget.posts.length > 0;
    const filterOptions = {
      'latest': i18n.t('Latest posts'),
      'popular': i18n.t('Popular posts'),
    };

    return (
      <div>
        {isPinnedPostsLinkEnabled && (
          <Link
            as={`/${community.slug}/posts#pinned`}
            href={`/community/communityPosts?slug=${community.slug}`}
          >
            <a
              className="community__home-pinned-button"
              onClick={() => {
                trackFootfallEvent(footfallEventTypes.CLICKED, {
                  clickType: 'pinned-posts',
                  clickMetadata: { section: 'mobile-shortcut' },
                });
              }}
            >
              <div>{i18n.t('Pinned posts')}</div>
              <div>
                <span className="icon icon-right-open" />
              </div>
            </a>
          </Link>
        )}
        <div className="community__home-filter">
          <PostFilterDropdown
            options={filterOptions}
            value={filter}
            onChange={value => fetchPosts(community.slug, value)}
          />
        </div>
        {!isPostListLoading ? this.renderPostList() : <PostListLoader />}
        {isWriteCTAvisible && <FooterCTA community={community} currentUser={currentUser} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { currentCommunity } = state.context;
  const isWriteCTAvisible = currentCommunity && !config.hideWriteCTA.includes(currentCommunity.slug)
    && !currentCommunity.isArchived;
  return {
    isWriteCTAvisible,
  };
};

export default connect(mapStateToProps, null)(CommunityHomeContent);
